export default __webpack_public_path__ + "static/media/adobeXD.71f4a396.png";